module.exports = __webpack_public_path__ + "static/media/coins.d843a2e1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/coins.svg
// module id = ./src/assets/icons/coins.svg
// module chunks = 0